export enum DistributionPlace {
  QRCode = "qrcode",
  PLV = "plv",
  Online = "online"
}
